import { DRIVER_DASHBOARD, RIDER_DASHBOARD, AGENT_DASHBOARD, BOOKINGS_HISTORY, CURRENT_BALANCE,AGENT_BALANCE, AGENT_COMMISSION, AGENT_WITHDRAWALS } from "App/store/constants";
const initialState = {
  driverData: null,
  riderData: null,
  bookingHistory: null,
  agentData: null,
  currentBalance: null,
  agentBalance:null,
  agentCommission: null,
  agentWithdrawals: null,
  errors: {},
  loading: false,
  // Per-slice loaders so commission/withdrawals/balance cards can show their own
  // skeletons without being tied to the global dashboard `loading` flag.
  commissionLoading: false,
  withdrawalsLoading: false,
  balanceLoading: false,
};

const reducer = (state = initialState, action: any) => {
  switch (action.type) {
    case DRIVER_DASHBOARD.PENDING:
      return { ...state, loading: true };
    case DRIVER_DASHBOARD.SUCCESS:
      const temp: any = [['Date', 'Completed', 'Cancelled', 'Not Accepted']];
      Object.entries(action.payload.data.rec).forEach((item) => {
        temp.push(item[1]);
      });
      action.payload.data.rec = temp;
      action.payload.data.latest = [];
      return { ...state, loading: false, driverData: action.payload.data };
    case DRIVER_DASHBOARD.FAILURE:
      return {
        ...state,
        loading: false,
        errors: action.payload,
      };

    case RIDER_DASHBOARD.PENDING:
      return { ...state, loading: true };
    case RIDER_DASHBOARD.SUCCESS:
      return { ...state, loading: false, riderData: action.payload.data };
    case RIDER_DASHBOARD.FAILURE:
      return { ...state, loading: false, errors: action.payload };


    case AGENT_DASHBOARD.PENDING:
      return { ...state, loading: true };
    case AGENT_DASHBOARD.SUCCESS:
      return { ...state, loading: false, agentData: action.payload };
    case AGENT_DASHBOARD.FAILURE:
      return { ...state, loading: false, errors: action.payload };



    case BOOKINGS_HISTORY.PENDING:
      return { ...state, loading: true };
    case BOOKINGS_HISTORY.SUCCESS:
      return { ...state, loading: false, bookingHistory: action.payload.data.data };
    case BOOKINGS_HISTORY.FAILURE:
      return { ...state, loading: false, errors: action.payload };

    case CURRENT_BALANCE.PENDING:
      return { ...state, loading: true };
    case CURRENT_BALANCE.SUCCESS:
      return { ...state, loading: false, currentBalance: action.payload.data };
    case CURRENT_BALANCE.FAILURE:
      return { ...state, loading: false, errors: action.payload };

    // Balance uses its own loader so it doesn't block the main dashboard spinner.
    case AGENT_BALANCE.PENDING:
      return { ...state, balanceLoading: true };
    case AGENT_BALANCE.SUCCESS:
      return { ...state, balanceLoading: false, agentBalance: action.payload.data };
    case AGENT_BALANCE.FAILURE:
      return { ...state, balanceLoading: false, errors: action.payload };

    // Commission summary { balance, total, today, week, month, commission_series }
    case AGENT_COMMISSION.PENDING:
      return { ...state, commissionLoading: true };
    case AGENT_COMMISSION.SUCCESS:
      return { ...state, commissionLoading: false, agentCommission: action.payload.data };
    case AGENT_COMMISSION.FAILURE:
      return { ...state, commissionLoading: false, errors: action.payload };

    case AGENT_WITHDRAWALS.PENDING:
      return { ...state, withdrawalsLoading: true };
    case AGENT_WITHDRAWALS.SUCCESS:
      return { ...state, withdrawalsLoading: false, agentWithdrawals: action.payload.data };
    case AGENT_WITHDRAWALS.FAILURE:
      return { ...state, withdrawalsLoading: false, errors: action.payload };


    default:
      return state;
  }
};

export default reducer;
